import BlankLayout from './BlankLayout'
export default BlankLayout